module.exports = __webpack_public_path__ + "static/media/image_17.59e35fe9.png";